export default __webpack_public_path__ + "static/media/2be574a8953cd7fe16fa799f2540de75.2c30b55a.svg";